import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import FilterJackpotPaymentReports from 'views/regulations/jackpotPayment/filterJackpotPaymentReports'; // Importing filter component
import TableJackpotPaymentReports from 'views/regulations/jackpotPayment/tableJackpotPaymentReports'; // Importing table component

/**
 * Class representing the Jackpot Payment Report View.
 * @extends JetView
 */
export default class JackpotPaymentReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        let vthis = this; // Reference to the current instance

        // Toolbar configuration
        const toolbar = {
            id: 'toolbar',
            view: 'toolbar',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting page size
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for page size change
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                            $$('datatable').scrollTo(100, 0); // Scroll to top
                            vthis.app.callEvent('changeSize', [{}]); // Trigger size change event
                        },
                    },
                },
                {
                    id: 'pagerA', // Pager component
                    view: 'pager',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                },
                {
                    id: 'Export', // Export dropdown
                    view: 'richselect',
                    name: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder for export options
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value === 1) {
                                // Excel export
                                let table = $$('datatable'); // Reference to the data table
                                for (let j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    // Trigger export data event
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _(
                                                'Reportes de Pago del Premio Mayor (Sistemas Progresivos) (Deportivas) (8.7.6)',
                                            ),
                                        TypeReport: 'Excel', // Specify report type
                                    },
                                ]);
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _(
                                            'Reportes de Pago del Premio Mayor (Sistemas Progresivos) (Deportivas) (8.7.6)',
                                        ),
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _(
                                                    'Reportes de Pago del Premio Mayor (Sistemas Progresivos) (Deportivas) (8.7.6)',
                                                ),
                                            TypeReport: 'PDF', // Specify report type
                                        },
                                    ]);
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _(
                                                'Reportes de Pago del Premio Mayor (Sistemas Progresivos) (Deportivas) (8.7.6)',
                                            ),
                                        autowidth: true, // Enable auto width for PDF
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        {
                            css: 'int-left',
                            rows: [
                                {
                                    view: 'toolbar', // Toolbar for report title and actions
                                    css: theme,
                                    elements: [
                                        {
                                            view: 'label',
                                            label: _(
                                                'Reportes de Pago del Premio Mayor (Sistemas Progresivos) (Deportivas) (8.7.6)',
                                            ),
                                        },
                                        {
                                            id: 'button-search', // Search button
                                            type: 'wide',
                                            css: 'close-bottom',
                                            cols: [
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-search',
                                                    bottom: 20,
                                                    right: 35,
                                                    width: 30,
                                                    height: 30,
                                                    click: () => {
                                                        // Click event to show filter popup
                                                        $$('filterPopup').show();
                                                    },
                                                },
                                            ],
                                        },
                                        {
                                            type: 'wide',
                                            css: 'close-bottom',
                                            cols: [
                                                {
                                                    view: 'icon',
                                                    icon: 'wxi-close', // Close button
                                                    bottom: 20,
                                                    right: 35,
                                                    width: 30,
                                                    height: 30,
                                                    click: () =>
                                                        // Click event to navigate to dashboard
                                                        this.show('/top/dashboard'),
                                                },
                                            ],
                                        },
                                    ],
                                },
                                FilterJackpotPaymentReports, // Filter component
                                TableJackpotPaymentReports, // Table component
                                toolbar, // Toolbar component
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                $$('toolbar').hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
